import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'

import UploadInstructions from '@/components/file-submission/UploadInstructions';
import UploadFilesCard from '@/components/file-submission/UploadFilesCard/UploadFilesCard';
import { FileEntry } from '@/models.ts';
import SubmittedFilesCard from '@/components/file-submission/SubmittedFilesCard/SubmittedFilesCard';
import LayoutContentArea from '@/components/layout/LayoutContentArea'

interface SubmittedFileEntry extends FileEntry {
    timeSubmitted: Date
}

export default function UploadFilePage() {

    // const [submittedFiles, setSubmittedFiles] = useState<SubmittedFileEntry[]>([]);

    // const handleFileSuccess = (fileEntry: FileEntry) => {
    //     const submittedFile = {
    //         ...fileEntry, 
    //         timeSubmitted: new Date()
    //     }
    //     setSubmittedFiles(prev => prev.concat(submittedFile));
    // }

    return (
        <LayoutContentArea 
            headingText="File Upload"
        >
           <UploadInstructions />

            <UploadFilesCard 
                // onFileSuccess={handleFileSuccess}
                className="mb-4"
            />

            <SubmittedFilesCard />
        </LayoutContentArea>
    )
}


